import React, { useContext, useState } from 'react'
import "./SensorDetailsContainer.css"
import { UnitContext } from '../../App';
import SensorDetailsScreen from './SensorDetailsScreen';
import { Loading } from '@sede-enterprise/shell-ds-react-framework';
import useLogReport from '../../util/hooks/useLogReport';
import useFetchSensorDetails from './hooks/useFetchSensorDetails';


const SensorDetailsContainer = (props) => {

  const unitContext = useContext(UnitContext)

  const { match } = props;

  const [alertThresholdUpdate, setAlertThresholdUpdate] = useState(null);
  const { sensorData} = useFetchSensorDetails(decodeURIComponent(match.params.id), alertThresholdUpdate);

  // Log report for the page
  useLogReport('SENSOR DETAIL');

  const loadingScreen = (
    <div className="sensor-details-loading loading-container" id='sensor-details-container-id-1' role='status'>
      <Loading />
    </div>
  );


  if (!sensorData || !sensorData.cmLocationId) return loadingScreen;

  return (
    <SensorDetailsScreen
      units={unitContext.units}
      sensorID={decodeURIComponent(match.params.id)}
      isRealSensor={sensorData.isRealSensor}
      rating={sensorData.sensorRating}
      cmlID={sensorData.cmLocationId}
      cmlName={sensorData.cmLocationName}
      clId={sensorData.corrosionLoop}
      equipmentId={sensorData.equipment}
      sensorData={sensorData}
      isUninstalled={sensorData.uninstalled}
      site={sensorData.siteId}
      prodUnit={sensorData.plant}
      alertThresholdUpdate={alertThresholdUpdate}
      setAlertThresholdUpdate={setAlertThresholdUpdate}
    />
  )
}

export default SensorDetailsContainer